export default {
  'comingsoon': 'Ця функція скоро з\'явиться!',
  'Account': 'Обліковий запис',
  'Already with an account?': 'Вже є обліковий запис?',
  'and': 'та',
  'Connect': 'Підключити',
  'Disconnect': 'Відключити',
  'Change profile picture': 'Змінити зображення профілю',
  'confirmed': 'підтверджено',
  'Consent': 'Згода',
  'copy': 'kопіювати',
  'Copy': 'Копіювати',
  'Community': 'Спільнота',
  'Decline': 'Відмовитися',
  'Email': 'Електронна пошта',
  'Firstname': 'Ім\'я',
  'Home': 'Головна',
  'I agree to the': 'Я згоден з',
  'Imprint': 'Відбиток',
  'Lastname': 'Прізвище',
  'Learn': 'Вчитися',
  'Learning': 'Навчання',
  'login': 'Увійти',
  'Login': 'Увійти',
  'logout': 'Вийти',
  'password': 'Пароль',
  'Password': 'Пароль',
  'Pricing': 'Ціни',
  'privacy': 'Конфіденційність',
  'Privacy': 'Конфіденційність',
  'profile': 'Профіль',
  'Read more': 'Читати далі',
  'Register': 'Реєстрація',
  'Report a bug': 'Повідомити про помилку',
  'Remove': 'Видалити',
  'School': 'Школа',
  'Settings': 'Налаштування',
  'Simulator': 'Симулятор',
  'Subscription': 'Підписка',
  'Cancel subscription': 'Скасувати підписку',
  'Resume subscription': 'Відновити підписку',
  'Courses': 'Курси',
  'Submit': 'Надіслати',
  'tos': 'Умови обслуговування',
  'Wiki': 'Вікі',
  'Write': 'Писати',
  'Send': 'Надіслати',
  'Total': 'Всього',
  'Seen': 'Бачено',
  'Positive': 'Позитивний',
  'Catalogs': 'Каталоги',
  'Question': 'Питання',
  'per': 'за',
  'month': 'місяць',
  'Month': 'Місяць',
  'Monthly': 'Щомісячно',
  'Year': 'Рік',
  'Yearly': 'Щорічно',
  'Filter categories': 'Фільтрувати категорії',
  'Examples': 'Приклади',
  'Flightschool': 'Літня школа',
  'Your Name': 'Ваше ім\'я',
  'Phone': 'Телефон',
  'Request': 'Запит',
  'privacyagreement': 'Я погоджуюсь з угодою про захист даних та умовами обслуговування.',
  'Questions': 'Питання',
  'Lections': 'Лекції',
  'Scenarios': 'Сценарії',
  'Spelling': 'Правопис',
  'Listening': 'Слухання',
  'Tos': 'Умови обслуговування',
  'Tools': 'Інструменти',
  'Username': 'Ім\'я користувача',
  'username': 'ім\'я користувача',
  'Show hint again': 'Показати підказку знову',
  'Mark as read': 'Позначити як прочитане',
  'Search': 'Пошук',
}
